(
    function (doc, win) {
        function rem() {
            doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 10 + 'px';
            let html = doc.getElementsByTagName('html')[0];
            let winFontS = parseFloat(win.getComputedStyle(html).fontSize);
            let htmlFontS = parseFloat(html.style.fontSize);
            let setFontS = htmlFontS;
            if (winFontS != htmlFontS) {
                let whileCount = 0;
                while (true) {
                    winFontS = parseFloat(win.getComputedStyle(html).fontSize);
                    let delta = winFontS - htmlFontS;
                    if (Math.abs(delta) >= 0.1) {
                        if (delta > 0) setFontS = setFontS - 0.1;
                        else setFontS = setFontS + 0.1;
                        html.setAttribute('style', 'font-size:' + setFontS + 'px!important');
                    } else {
                        break;
                    }
                    if (whileCount++ > 200) {
                        break;
                    }
                }
            }
        }
        rem();
        win.addEventListener('resize', rem);
    }
)(document, window)